@let isFull = this.rack().isFull();
@let moreThanFull = this.rack().isMoreThanFull();
<div class="rack-label" [class.morefull]="moreThanFull">{{this.rack().type.label}} {{this.rack().type.hideNumber ? "" : this.rack().number}} 
    @if (this.canDelete()) {
        <button kendoButton (click)="this.onDelete()" [svgIcon]="icon" [size]="'small'"></button>

    }
</div>
@let karten = this.slotKaarten();
<div class="karten" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onDrop($event)">
    @for (k of karten; track $index) {
    <kart-view [kaartId]="k.id" [editDipSwitch]="this.editDipSwitch()" cdkDrag></kart-view>
    }
    <div>
        @let nextNummer = this.rack().getNextNumber();
        <!-- @let kartTypes = this.hdwMetaService.meta().getKaartenByBus(this.rack().type.bus); -->
        <div>
            <kendo-dropdownbutton [data]="this.kartTypes()" [textField]="'label'" [themeColor]="isFull ?  'inverse' : 'tertiary'"
                (itemClick)="this.onKaartAdded($event)">
                {{'Kaart' | translate: 'Kaart'}} {{nextNummer}}
            </kendo-dropdownbutton>
        </div>
    </div>
</div>